











import Enumerable from "linq";
import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import { StandardOption } from "../../system/selectors/mixins";
import { DesignatedDoctorSelectableMixin } from "./mixins";
import { DesignatedDoctorInformation } from "../../../domain/user";
import { FixedLoading } from "../../system";

@Component({
  components: {
    OptionDropDownSelector,
    FixedLoading,
  },
})
export default class DesignatedDoctorDropDownSelector extends Mixins(DesignatedDoctorSelectableMixin) {
  editingSource: DesignatedDoctorInformation[];

  @Prop({ default: true })
  isClearable: boolean;

  @Watch("isLoaded")
  onIsLoadedUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue) {
      this.loaded(this.options);
    }
  }

  @Watch("selectedDesignatedDoctor")
  onSelectedDesignatedDoctorUpdated(newValue: DesignatedDoctorInformation, oldValue: DesignatedDoctorInformation) {
    this.editingSource = newValue
      ? Enumerable.from(this.validDesignatedDoctorInformations).where(v => v.typeCode === newValue.typeCode).toArray()
      : null;
  }

  @Emit()
  loaded(options: StandardOption<DesignatedDoctorInformation>[]): void {}
}
